// Popup component for listing Actual Progress submissions for a task
// UI kept lightweight (no MUI) to avoid extra deps within gantt-new.
// Props:
// - open: boolean
// - onClose: function
// - task: { id, text }
// - items: array of submissions with attachments [{ id, createdAt, volume, unit, status, taskName, attachments: [{id, fileName, url}] }]
// - loading: boolean

import React from 'react';

export default function ActualProgressDialog({ open, onClose, task, items = [], loading = false }) {
  if (!open) return null;
  const fmtDate = (d) => {
    if (!d) return '-';
    try { return new Date(d).toLocaleString('id-ID', { day:'2-digit', month:'short', year:'numeric' }); } catch(_) { return String(d); }
  };
  return (
    <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.35)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center'}} onClick={onClose}>
      <div style={{background:'#fff', borderRadius:10, width:'1400px', maxWidth:'98vw', maxHeight:'90vh', overflow:'auto', boxShadow:'0 12px 36px rgba(0,0,0,0.25)'}} onClick={(e)=>e.stopPropagation()}>
        <div style={{padding:'12px 16px', borderBottom:'1px solid #eee', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <div style={{fontWeight:700, fontSize:20}}>Daftar Progress Actual {task ? `- ${task.text}` : ''}</div>
          <button onClick={onClose} style={{border:'none', background:'#eee', borderRadius:4, padding:'6px 10px', cursor:'pointer'}}>Tutup</button>
        </div>
        <div style={{padding:'12px 16px'}}>
          {loading ? (
            <div>Memuat data...</div>
          ) : (!items || items.length === 0) ? (
            <div>Tidak ada progress actual untuk task ini.</div>
          ) : (
            <div style={{overflowX:'auto'}}>
              <table style={{width:'100%', borderCollapse:'collapse', fontSize:18}}>
                <thead>
                  <tr>
                    <th style={th}>Project</th>
                    <th style={th}>Kategori</th>
                    <th style={th}>Task</th>
                    <th style={th}>Dibuat</th>
                    <th style={th}>Work Date</th>
                    <th style={th}>Submitter</th>
                    <th style={th}>Reviewer</th>
                    <th style={th}>Volume</th>
                    <th style={th}>Status</th>
                    <th style={th}>Gambar</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(item => {
                    const workDate = item.progressWorkDate || item.progressworkdate || item.progress_date;
                    const atts = Array.isArray(item.attachments) ? item.attachments : [];
                    return (
                      <tr key={item.id}>
                        <td style={td}>{item.projectName || '-'}</td>
                        <td style={td}>{item.workCategoryName || '-'}</td>
                        <td style={td}>{item.taskName || '-'}</td>
                        <td style={td}>{fmtDate(item.createdAt)}</td>
                        <td style={td}>{fmtDate(workDate)}</td>
                        <td style={td}>{item.submitterName || '-'}</td>
                        <td style={td}>{item.reviewerName || '-'}</td>
                        <td style={td}>{item.volume != null ? item.volume : '-'}</td>
                        <td style={td}>{item.status || '-'}</td>
                        <td style={td}>
                          {atts.length === 0 ? (
                            <span style={{color:'#888'}}>Tidak ada</span>
                          ) : (
                            <div style={{display:'flex', flexWrap:'wrap', gap:6}}>
                              {atts.map(att => (
                                <a key={att.id} href={att.url} target="_blank" rel="noreferrer" style={{fontSize:12, color:'#1976d2', textDecoration:'none', border:'1px solid #ddd', padding:'4px 6px', borderRadius:4}}>
                                  {att.fileName || 'Download'}
                                </a>
                              ))}
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <td style={tf} colSpan={7}>Total Volume</td>
                    <td style={{...tf, fontWeight:800}}>
                      {(() => {
                        const total = (items || []).reduce((s, it) => s + (Number(it.volume) || 0), 0);
                        // Try to derive unit from the first item or task prop
                        const unit = (items && items[0] && items[0].unit) || (task && task.unit) || '';
                        return unit ? `${total.toFixed(2)} ${unit}` : total.toFixed(2);
                      })()}
                    </td>
                    <td style={tf} colSpan={2}></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const th = { textAlign:'left', padding:'12px', borderBottom:'1px solid #eee', background:'#fafafa', fontWeight:700, fontSize:18 };
const td = { padding:'12px', borderBottom:'1px solid #f3f3f3', fontSize:18, lineHeight: '1.6' };
const tf = { padding:'12px', borderTop:'2px solid #ddd', fontSize:18, background:'#fafafa' };
